module.exports = __webpack_public_path__ + "static/media/settings.92c25f37.png";